<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemCollege.libelle}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busyGet,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Filiale :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" disabled placeholder="Filiale" autocomplete="off"
                            [(ngModel)]="itemCollege.filiale_libelle" name="filiale_libelle" autocomplete="off"
                            type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Garant :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" disabled placeholder="Garant" autocomplete="off"
                            [(ngModel)]="itemCollege.garant_libelle" name="garant_libelle" autocomplete="off"
                            type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Police :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" disabled placeholder="Police" autocomplete="off"
                            [(ngModel)]="itemCollege.police_libelle" name="police_libelle" autocomplete="off"
                            type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">

                        <label (click)="openModalDetailBareme()"
                            [ngClass]="{'isSelectedItem':itemCollege.bareme_id}">Barème :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" disabled placeholder="Bareme" autocomplete="off"
                            [(ngModel)]="itemCollege.bareme_libelle" name="bareme_libelle" autocomplete="off"
                            type="text" />
                    </div>


                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux couverture:
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Taux couverture"
                            autocomplete="off" [(ngModel)]="itemCollege.taux_couverture" name="taux_couverture"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Code:
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Code" autocomplete="off"
                            [(ngModel)]="itemCollege.code" name="code" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Codification:
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Codification" autocomplete="off"
                            [(ngModel)]="itemCollege.codification" name="codification" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Libellé :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                            [(ngModel)]="itemCollege.libelle" name="libelle" autocomplete="off" type="text" />
                    </div>


                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Date effet :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Date effet" autocomplete="off"
                            [(ngModel)]="itemCollege.date_effet" name="date_effet" autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Date échéance :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Date échéance" autocomplete="off"
                            [(ngModel)]="itemCollege.date_echeance" name="date_echeance" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Type remboursement :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Taux couverture"
                            autocomplete="off" [(ngModel)]="itemCollege.taux_couverture" name="taux_couverture"
                            autocomplete="off" type="text" />
                    </div>


                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Délai de carence (jours) :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Délai de carence" autocomplete="off"
                            [(ngModel)]="itemCollege.delai_carence" name="delai_carence" autocomplete="off" type="text"
                            mask="separator">
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil alerte consommation (%) :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Seuil alerte conso" autocomplete="off"
                            [(ngModel)]="itemCollege.seuil_alerte_conso" name="seuil_alerte_conso" autocomplete="off"
                            type="text" />
                    </div>



                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil suspension tiers payant (%) :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Seuil suspension tp" autocomplete="off"
                            [(ngModel)]="itemCollege.seuil_suspension_tiers_payant" name="seuil_suspension_tiers_payant"
                            autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>A qui rembourser? :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Taux couverture"
                            autocomplete="off" [(ngModel)]="itemCollege.taux_couverture" name="taux_couverture"
                            autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Mode tarification :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Taux couverture"
                            autocomplete="off" [(ngModel)]="itemCollege.taux_couverture" name="taux_couverture"
                            autocomplete="off" type="text" />
                    </div>




                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label (click)="openModalPrestataireReseau()"
                            [ngClass]="{'isSelectedItem':itemCollege.reseau_de_soin_id}">Réseau de soin :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Taux couverture"
                            autocomplete="off" [(ngModel)]="itemCollege.taux_couverture" name="taux_couverture"
                            autocomplete="off" type="text" />
                    </div>



                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                        <label>Statut :
                            <span class="required_champs">*</span>
                        </label>
                        <input disabled class="form-control custom-input" placeholder="Taux couverture"
                            autocomplete="off" [(ngModel)]="itemCollege.taux_couverture" name="taux_couverture"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemCollege.is_prorata_prime" id="is_prorata_prime" name="is_prorata_prime"
                            autocomplete="off" type="checkbox" />
                        <label for="is_prorata_prime">Prorata prime?
                        </label>
                    </div>


                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">


        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>